import { useMemo } from 'react';

import { ShouldNotHappen } from 'utils';

import {
  DossierBodyResponseDto,
  FicheJudiciaireDtoValeurJuridiqueEnum,
  JuridictionResponseDto,
  UpdateDonneesJudiciairesRequestDtoNewValeurJuridiqueEnum,
} from 'lib_api/lib/api/gen';

import { UpdateDonneesJudiciairesFormValues } from 'hooks/updateDonneesJudiciaires/types';

function useInitialValues(
  dossier: DossierBodyResponseDto | null | undefined,
  actualJuridiction?: JuridictionResponseDto,
): UpdateDonneesJudiciairesFormValues {
  return useMemo(() => {
    const juridictionOption = actualJuridiction
      ? {
          value: actualJuridiction.idCorrelation,
          label: actualJuridiction.libelle,
          option: actualJuridiction,
        }
      : undefined;
    const ficheJudiciaire = dossier?.ficheJudiciaire;
    const valeurJuridique = ficheJudiciaire?.valeurJuridique;

    return {
      newJuridiction: juridictionOption,
      newNumeroParquet: ficheJudiciaire?.numeroParquet ?? undefined,
      newNumeroPv: ficheJudiciaire?.numeroPv ?? undefined,
      newNumeroIDJ: ficheJudiciaire?.numeroIDJ ?? undefined,
      newValeurJuridique: valeurJuridique
        ? mapFicheJudiciaireDtoValeurJuridiqueEnumToUpdateDonneesJudiciairesRequestDtoNewValeurJuridiqueEnum(
            valeurJuridique,
          )
        : undefined,
    };
  }, [dossier, actualJuridiction]);
}

function mapFicheJudiciaireDtoValeurJuridiqueEnumToUpdateDonneesJudiciairesRequestDtoNewValeurJuridiqueEnum(
  value: FicheJudiciaireDtoValeurJuridiqueEnum,
): UpdateDonneesJudiciairesRequestDtoNewValeurJuridiqueEnum {
  switch (value) {
    case FicheJudiciaireDtoValeurJuridiqueEnum.PROBATOIRE:
      return UpdateDonneesJudiciairesRequestDtoNewValeurJuridiqueEnum.PROBATOIRE;
    case FicheJudiciaireDtoValeurJuridiqueEnum.CONFISCATOIRE:
      return UpdateDonneesJudiciairesRequestDtoNewValeurJuridiqueEnum.CONFISCATOIRE;
    default:
      throw new ShouldNotHappen(value);
  }
}

export default useInitialValues;
